export default __webpack_public_path__ + "static/media/email.60b4561b.svg";